import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CMSService } from '../../../services/cms-service';

@Component({
  selector: 'app-text',
  templateUrl: './text.component.html',
  styleUrls: ['./text.component.scss']
})
export class TextComponent implements OnInit {
  pdfSrc: string = "assets/file/text/Texte de base et circulaire d'application/Circulaire de mise en place d'un service Médico-Sanitaire.pdf";
  pdfSrc2: string = "assets/file/text/Texte de base et circulaire d'application/Décret N°94-077 fixant  le régime des soins médicaux.pdf";
  pdfSrc3: string = "assets/file/text/Texte de base et circulaire d'application/Circulaire d'application du régime d'hospitalisation du Décret N°94-077.pdf";
  pdfSrc4: string = "assets/file/text/Texte de base et circulaire d'application/Madagascar_Code_de_la_Sante.pdf";
  mode_lois : number = 1;
  infoText: any;

  constructor(private router: Router,public cmsService: CMSService, ) { }

  ngOnInit() {
    this.getIecText();
  }


  

  getIecText() {
    this.cmsService.getText()
      .subscribe(data => {
        this.infoText = data
      },
        err => {
          console.log(err);
        })
  }

  rechercheText(mcl){
    if(mcl==""){
      this.getIecText();
    }else {
      this.cmsService.getTextParmocle(mcl)
      .subscribe(data => {
        this.infoText = data
      },
        err => {
          console.log(err);
        })
    }
    
  }

  details(id_text:any){  
    console.log(id_text)
    this.router.navigate(['detail_text/'+id_text]);    
  }
  
  return(){
    this.mode_lois = 1;
  }
  

}
